export default __webpack_public_path__ + "static/media/IconDesc_Mycelia.256.eacb7444.png";